import restClient from 'Shared/hooks/restClient'
import templates from './templates'

const actionSlices = {
  templates,
}

export default () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(actionSlices, (fn) => {
      return fn(dis, store, restClient)
    }),
    []
  )
}
